module.exports = __webpack_public_path__ + "static/media/shaker_06.36220ce4.jpg";